<template>
  <Page v-bind="page"/>
</template>
<script>
import Page from "@/components/Page/BasisListPage.vue";
import rules from "@/rules";
import { alert, showDialog } from "@/utils";
import ReplayList from "./ReplayList.vue";
export default {
  props: {
    success: Function,
    close: Function,
    pars: Object
  },
  components: {
    Page
  },
  data() {
    return {
      page: {
        moduleInfo: {
          area: "Business",
          name: "UserComment",
          direction: "用户留言",
          frmColumns(cols) {
            cols.push({
              Name: "ReplayCount",
              Type: "Int32",
              Description: "回复次数"
            });
            return cols;
          },
          toolItems: [
            {
              name: "AddReplay",
              title: "添加回复",
              icon: "playlist_add",
              disabled({ selection }) {
                return selection.length != 1;
              },
              async action({ selection, rows }) {
                let { Id } = selection[0];
                let { content } = await this.$message.prompt({
                  title: "添加回复",
                  maxWidth: "500px",
                  model: {
                    content: ""
                  },
                  options: [
                    {
                      Name: "content",
                      Type: "String",
                      IsTextArea: true,
                      Description: "回复内容",
                      rules: [rules.required("回复内容")]
                    }
                  ]
                });
                let result = await this.$http.put(
                  `/api/UserComment/AddReplay/${Id}?replyContent=${content}`
                );
                alert.success("添加成功!");
                let index = rows.findIndex(r => r.Id == Id);
                if (index > -1) {
                  selection[0].ReplayCount += 1;
                }
              }
            },
            {
              name: "Get",
              title: "查看回复",
              icon: "playlist_add_check",
              disabled({ selection }) {
                return selection.length != 1;
              },
              action({ selection, rows }) {
                let { Id } = selection[0];
                showDialog(ReplayList, { Id });
              }
            }
          ]
        },
        pageInfo: {
          success: this.success,
          close: this.close,
          pars: this.pars
        }
      }
    };
  }
};
</script>
